import { Navigate } from 'react-router-dom'

const Home = (): JSX.Element => <Navigate to="/bridge" />

export default Home
